import React, { Component, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { Typography, withStyles } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import { CountryRegionData } from "react-country-region-selector";
import { CountryRegionDataUSFirst } from "common/countries";
import {
  ADD_MYDEALER_USER,
  GET_ALL_SALES_REP,
  getAllDealerOptions,
} from "queries";
import { Mutation, Query } from "react-apollo";
import { toast } from "react-toastify";
import useForm from "components/useForm";
import auth from "Auth";
import axios from "axios";
import auth0User from "components/Auth0User";
import { DEALER_ASSIGN } from "pages/Sales/queries";
import { useQuery } from "@apollo/client";
import { CircularProgress } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "2em",
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: "100%",
    margin: "1em",
    textAlign: "center",
  },
  dense: {
    marginTop: 19,
  },
  formControl: {
    margin: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  addDealer: {
    width: "200px",
    fontSize: "18px",
    fontWeight: "300",
    textTransform: "uppercase",
    textAlign: "center",
  },
  addDealerBtn: {
    width: "200px",
    padding: "1em",
    fontSize: "14px",
  },
  checkBoxTitle: {
    fontSize: "18px",
    textTransform: "uppercase",
    color: "#1f3340",
    fontWeight: "300",
  },
}));

const getRegions = (country) => {
  if (!country) {
    return [];
  }
  //console.log("regions");
  return country[2].split("|").map((regionPair) => {
    let [regionName, regionShortCode = null] = regionPair.split("~");
    return regionName;
  });
};

const AddDealer = (props) => {
  const { values, handleChange, resetState, handleChangeCheckbox } =
    useForm(submitForm);
  const classes = useStyles();
  const [isSubmit, setIsSubmit] = useState(false);

  const {
    loading: salesLoading,
    data: salesData,
    error,
    refetch,
  } = useQuery(GET_ALL_SALES_REP, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  // values.start_date = new Date().getDate()
  function submitForm() {
    //console.log(values);
  }

  function permissionsCreator() {
    let permissionsArray = [];

    if (values.DEALER_ALL === true) {
      let permissionsArray = [];
      permissionsArray.push("dealer:DEALER_ALL");
      return permissionsArray;
    }
    if (values.DEALER_LEADS === true) {
      permissionsArray.push("dealer:DEALER_LEADS");
    }
    if (values.DEALER_WARRANTY === true) {
      permissionsArray.push("dealer:DEALER_WARRANTY");
    }
    if (values.DEALER_FORMS_DATASHEETS === true) {
      permissionsArray.push("dealer:DEALER_FORMS_DATASHEETS");
    }
    if (values.DEALER_MEDIA === true) {
      permissionsArray.push("dealer:DEALER_MEDIA");
    }
    if (values.DEALER_INVENTORY === true) {
      permissionsArray.push("dealer:DEALER_INVENTORY");
    }
    if (values.DEALER_ORDER_BOATS === true) {
      permissionsArray.push("dealer:DEALER_ORDER_BOATS");
    }
    if (values.DEALER_CSI === true) {
      permissionsArray.push("dealer:DEALER_CSI");
    }
    if (values.DEALER_FACTORY_CONTACTS === true) {
      permissionsArray.push("dealer:DEALER_FACTORY_CONTACTS");
    }
    if (values.DEALER_BOAT_SHOWS === true) {
      permissionsArray.push("dealer:DEALER_BOAT_SHOWS");
    }
    if (values.DEALER_ORDER_BOAT_DETAIL === true) {
      permissionsArray.push("dealer:DEALER_ORDER_BOAT_DETAIL");
    }
    if (values.DEALER_ORDER_BOAT === true) {
      permissionsArray.push("dealer:DEALER_ORDER_BOAT");
    }
    if (values.DEALER_SKIFF_MERCHANDISE === true) {
      permissionsArray.push("dealer:DEALER_SKIFF_MERCHANDISE");
    }

    return permissionsArray;
  }

  function createNewUser(data, callBackMutation, dealerAssign, error) {
    console.log("error------------>", error);

    setIsSubmit(true);
    let formData = {};
    let accessTokenPromise = auth0User.getToken();
    let AUTH_API_URL = auth0User.AUTH_API_URL();

    accessTokenPromise
      .then((accessToken) => {
        console.log("formdata", formData);

        formData.name = data?.name;
        formData.email = data?.email;
        formData.company = data?.company;
        formData.address = data?.address;
        formData.address2 = data?.address2;
        formData.city = data?.city;
        formData.phone = data?.phone;
        formData.has_skiff = data?.has_skiff;
        formData.has_funchaser = data?.has_funchaser;
        formData.has_seachaser = data?.has_seachaser;
        formData.region = data?.region;
        formData.zipcode = data?.zipcode;
        formData.dealer_code = data?.dealer_code;
        formData.country = data?.country[0];
        formData.role = "Dealer";
        formData.parent_admin = auth.getSub();
        formData.is_sales_assign = true;
        formData.business_email = data?.business_email;

        axios
          .get(`https://maps.googleapis.com/maps/api/geocode/json`, {
            params: {
              address:
                values?.address +
                " " +
                values?.city +
                " " +
                values?.region +
                "," +
                values?.country[0] +
                " " +
                values?.zipcode,
              key: process.env.REACT_APP_GOOGLE_API_KEY,
            },
          })
          .then(function (response) {
            const { lat, lng } =
              response?.data?.results?.[0]?.geometry?.location;
            formData.location =
              '{ "type": "Point", "coordinates": [' + lng + ", " + lat + "] }";

            axios({
              url: AUTH_API_URL + "users-by-email",
              method: "get",
              headers: { Authorization: `Bearer ${accessToken}` },
              params: {
                email: formData?.email,
              },
            })
              .then(function (response) {
                if (response.data !== undefined || response.data.length === 0) {
                  let auth0permissions = permissionsCreator();

                  axios({
                    url: AUTH_API_URL + "users",
                    method: "post",
                    headers: { Authorization: `Bearer ${accessToken}` },
                    data: {
                      connection: "Username-Password-Authentication",
                      email: formData?.email,
                      name: formData?.name,
                      password: data?.password,
                      user_metadata: {
                        full_name: formData?.name,
                        dealer_code: formData?.dealer_code,
                      },
                      email_verified: false,
                      app_metadata: {
                        role: "dealer",
                        permissions: auth0permissions,
                        dealer_code: formData?.dealer_code,
                      },
                    },
                  })
                    .then(function (response) {
                      let user_id = response.data.user_id;
                      let permissions = permissionsCreator();
                      formData.permissions = permissions;
                      formData.profile_id = user_id;

                      delete data.password;
                      delete data.lastname;
                      delete data.firstname;
                      delete data.error;

                      callBackMutation({
                        variables: {
                          objects: [formData],
                        },
                      })
                        .then((res) => {
                          const collectData = salesData?.profiles?.filter(
                            (item) => {
                              try {
                                const regions = JSON.parse(
                                  item?.assign_region || "[]",
                                );
                                return regions.some(
                                  (region) =>
                                    region.toLowerCase() ===
                                    data?.region?.toLowerCase(),
                                );
                              } catch (e) {
                                return false;
                              }
                            },
                          );
                          if (collectData?.[0]) {
                            dealerAssign({
                              variables: {
                                objects: [
                                  {
                                    profile_id: collectData?.[0]?.profile_id,
                                    assign_user_id:
                                      res?.data?.insert_profiles?.returning?.[0]
                                        ?.profile_id,
                                    regions: data?.region,
                                  },
                                ],
                              },
                            });
                          }
                        })
                        .catch((error) => {
                          // Handle GraphQL errors from the mutation
                          console.error("GraphQL Error:", error);
                          setIsSubmit(false);

                          // Check if it's a duplicate dealer code error
                          if (
                            error.graphQLErrors &&
                            error.graphQLErrors.some(
                              (err) =>
                                err.message.includes("duplicate key value") &&
                                err.message.includes(
                                  "profiles_dealer_code_key",
                                ),
                            )
                          ) {
                            toast.error(
                              `Dealer code "${data?.dealer_code}" already exists. Please use a different dealer code.`,
                              {
                                position: toast.POSITION.TOP_LEFT,
                              },
                            );
                          } else {
                            // Handle other GraphQL errors
                            const errorMessage =
                              error.graphQLErrors
                                ?.map((err) => err.message)
                                .join(", ") ||
                              "An error occurred while adding the dealer.";
                            toast.error(errorMessage, {
                              position: toast.POSITION.TOP_LEFT,
                            });
                          }
                        });
                      return true;
                    })
                    .catch(function (error) {
                      if (error.response?.status === 409) {
                        toast.error(
                          `User with email "${formData?.email}" already exists. Please use a different email address.`,
                          {
                            position: toast.POSITION.TOP_LEFT,
                          },
                          setIsSubmit(false),
                        );
                      } else if (error.response?.data?.message) {
                        toast.error(`Error: ${error.response.data.message}`, {
                          position: toast.POSITION.TOP_LEFT,
                        });
                      } else {
                        toast.error(
                          `Error creating user in Auth0: ${
                            error.message || error
                          }`,
                          {
                            position: toast.POSITION.TOP_LEFT,
                          },
                        );
                      }
                    });
                }
              })
              .catch(function (error) {
                if (error.response?.status === 404) {
                  toast.error(
                    "Auth0 API endpoint not found. Please check your configuration.",
                    {
                      position: toast.POSITION.TOP_LEFT,
                    },
                  );
                } else if (error.response?.status === 401) {
                  toast.error(
                    "Authentication failed. Please check your Auth0 credentials.",
                    {
                      position: toast.POSITION.TOP_LEFT,
                    },
                  );
                } else {
                  toast.error(
                    `Error checking if user exists: ${error.message || error}`,
                    {
                      position: toast.POSITION.TOP_LEFT,
                    },
                  );
                }
              });
          })
          .catch((error) => {
            toast.error("Error Getting GEO Location For Address: " + error, {
              position: toast.POSITION.TOP_LEFT,
            });
            setIsSubmit(false);
          });
        return true;
      })
      .catch(function (error) {
        setIsSubmit(false);
        toast.error(
          "Error from getToken() with async( When promise gets rejected ): " +
            error,
          {
            position: toast.POSITION.TOP_LEFT,
          },
        );
      });
  }

  function validatePassword() {
    if (values.password !== values.repassword) {
      //   values.setCustomValidity("Passwords Don't Match");
    } else {
      //  values.repassword.setCustomValidity('');
    }
  }

  function completedAdd(payload) {
    //console.log("completeAdd has been called" + payload);
    toast("New Dealer User has been created succesfully");
    resetState();
    setIsSubmit(false);
  }

  return (
    <>
      {salesLoading ? (
        <CircularProgress />
      ) : (
        <Query query={getAllDealerOptions}>
          {({ loading, error, data: dealer }) => {
            if (loading) return <p>Loading dealer info...</p>;
            if (error) return <p>Error loading dealer info</p>;

            return (
              <Mutation
                mutation={ADD_MYDEALER_USER}
                onCompleted={completedAdd}
                // Refresh the cached dealer list so the new dealer shows up
                // in every dealer dropdown (e.g. Boat Shows) without a reload
                refetchQueries={[{ query: getAllDealerOptions }]}
              >
                {(addNewDealerUser, { data, loading, called, error }) => (
                  <Mutation
                    mutation={DEALER_ASSIGN}
                    onError={() => setIsSubmit(false)}
                  >
                    {(dealerAssign, { data, loading, called, error }) => (
                      <form
                        onSubmit={(e) => {
                          values.email = values?.email?.toLowerCase();
                          e.preventDefault();
                          createNewUser(
                            values,
                            addNewDealerUser,
                            dealerAssign,
                            error,
                          );
                        }}
                        className={classes.container}
                        autoComplete="off"
                      >
                        <Typography
                          gutterBottom
                          variant="h2"
                          className={classes.addDealer}
                        >
                          Add New Dealer
                        </Typography>

                        <Grid
                          container
                          direction="row"
                          justify="space-between"
                          alignItems="center"
                        ></Grid>
                        {/* Row 1 - Email, Business Email, Password */}
                        <Grid
                          container
                          direction="row"
                          justify="space-between"
                          alignItems="center"
                          wrap="nowrap"
                        >
                          <TextField
                            id="email"
                            name="email"
                            label="Email"
                            placeholder=""
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.email || ""}
                            required
                            variant="outlined"
                          />
                          <TextField
                            id="business_email"
                            name="business_email"
                            label="Business Email"
                            placeholder=""
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.business_email || ""}
                            variant="outlined"
                          />
                          <TextField
                            id="password"
                            name="password"
                            label="Password"
                            placeholder="Password"
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.password || ""}
                            required
                            type="password"
                            variant="outlined"
                            inputProps={{
                              pattern: ".{8,}",
                            }}
                          />
                        </Grid>

                        {/* Row 2 - Name, Phone, Company */}
                        <Grid
                          container
                          direction="row"
                          justify="space-between"
                          alignItems="center"
                          wrap="nowrap"
                        >
                          <TextField
                            id="name"
                            name="name"
                            label="Full Name"
                            placeholder="Full Name"
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.name || ""}
                            required
                            variant="outlined"
                          />
                          <TextField
                            id="phone"
                            name="phone"
                            label="Phone"
                            placeholder="Phone"
                            className={classes.textField}
                            margin="normal"
                            onChange={(e) => handleChange(e, "phone")}
                            value={values.phone || ""}
                            variant="outlined"
                          />
                          <TextField
                            id="company"
                            name="company"
                            label="Company Name"
                            placeholder="Company Name"
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.company || ""}
                            required
                            variant="outlined"
                          />
                        </Grid>

                        {/* Row 3 - Address, Address2, City */}
                        <Grid
                          container
                          direction="row"
                          justify="space-between"
                          alignItems="center"
                          wrap="nowrap"
                        >
                          <TextField
                            id="address"
                            name="address"
                            label="Address"
                            placeholder="Address"
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.address || ""}
                            required
                            variant="outlined"
                          />
                          <TextField
                            id="address2"
                            name="address2"
                            label="SUITE , APT # , Optional"
                            placeholder="SUITE , APT # , Optional"
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.address2 || ""}
                            variant="outlined"
                          />
                          <TextField
                            id="city"
                            name="city"
                            label="City"
                            placeholder="City"
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            value={values.city || ""}
                            required
                            variant="outlined"
                          />
                        </Grid>

                        {/* Row 4 - Country, Region, Zipcode, Dealer Code */}
                        <Grid
                          container
                          direction="row"
                          justify="space-between"
                          alignItems="center"
                          wrap="nowrap"
                        >
                          <TextField
                            id="country"
                            name="country"
                            label="Country"
                            value={values.country || ""}
                            select
                            onChange={handleChange}
                            className={classes.textField}
                            margin="normal"
                            inputProps={{
                              name: "country",
                              id: "country",
                            }}
                            variant="outlined"
                          >
                            {CountryRegionDataUSFirst.map((option, index) => (
                              <MenuItem key={option[0]} value={option}>
                                {option[0]}
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            id="region"
                            name="region"
                            label="Region"
                            value={values.region || ""}
                            select
                            className={classes.textField}
                            margin="normal"
                            onChange={handleChange}
                            variant="outlined"
                          >
                            {getRegions(values.country).map((option, index) => (
                              <MenuItem key={option[0]} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            id="zipcode"
                            name="zipcode"
                            label="Zipcode"
                            placeholder="Zipcode"
                            margin="normal"
                            onChange={handleChange}
                            value={values.zipcode || ""}
                            required
                            className={classes.textField}
                            variant="outlined"
                          />

                          <TextField
                            id="dealer_code"
                            name="dealer_code"
                            label="Dealer Code"
                            placeholder="Dealer Code"
                            margin="normal"
                            onChange={handleChange}
                            value={values.dealer_code || ""}
                            className={classes.textField}
                            variant="outlined"
                          />
                        </Grid>

                        {/* Permissions and Brands Section */}
                        <Grid container>
                          <Grid item xs={6} align="left">
                            <FormControl
                              required
                              component="fieldset"
                              className={classes.formControl}
                            >
                              <Typography className={classes.checkBoxTitle}>
                                Dealer Permissions
                              </Typography>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_ALL"
                                      checked={values.DEALER_ALL || false}
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_ALL"
                                    />
                                  }
                                  label="ALL"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_LEADS"
                                      checked={values.DEALER_LEADS || false}
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_LEADS"
                                    />
                                  }
                                  label="LEADS"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_WARRANTY"
                                      checked={values.DEALER_WARRANTY || false}
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_WARRANTY"
                                    />
                                  }
                                  label="WARRANTY"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_FORMS_DATASHEETS"
                                      checked={
                                        values.DEALER_FORMS_DATASHEETS || false
                                      }
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_FORMS_DATASHEETS"
                                    />
                                  }
                                  label="FORMS & DATA SHEETS"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_MEDIA"
                                      checked={values.DEALER_MEDIA || false}
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_MEDIA"
                                    />
                                  }
                                  label="MEDIA"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_CSI"
                                      checked={values.DEALER_CSI || false}
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_CSI"
                                    />
                                  }
                                  label="CSI"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_FACTORY_CONTACTS"
                                      checked={
                                        values.DEALER_FACTORY_CONTACTS || false
                                      }
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_FACTORY_CONTACTS"
                                    />
                                  }
                                  label="FACTORY CONTACTS"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_BOAT_SHOWS"
                                      checked={
                                        values.DEALER_BOAT_SHOWS || false
                                      }
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_BOAT_SHOWS"
                                    />
                                  }
                                  label="BOAT SHOWS"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="DEALER_SKIFF_MERCHANDISE"
                                      checked={
                                        values.DEALER_SKIFF_MERCHANDISE || false
                                      }
                                      onChange={handleChangeCheckbox}
                                      value="DEALER_SKIFF_MERCHANDISE"
                                    />
                                  }
                                  label="SKIFF MERCHANDISE"
                                />
                              </FormGroup>
                            </FormControl>
                          </Grid>

                          <Grid item xs={6} align="left">
                            <FormControl
                              required
                              component="fieldset"
                              className={classes.formControl}
                            >
                              <Typography className={classes.checkBoxTitle}>
                                BRANDS CARRIED
                              </Typography>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="has_skiff"
                                      checked={values.has_skiff || false}
                                      onChange={handleChangeCheckbox}
                                      value="has_skiff"
                                    />
                                  }
                                  label="CAROLINA SKIFF"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="has_funchaser"
                                      checked={values.has_funchaser || false}
                                      onChange={handleChangeCheckbox}
                                      value="has_funchaser"
                                    />
                                  }
                                  label="FUN CHASER"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="has_seachaser"
                                      checked={values.has_seachaser || false}
                                      onChange={handleChangeCheckbox}
                                      value="has_seachaser"
                                    />
                                  }
                                  label="SEA CHASER"
                                />
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12} align="center">
                          <Button
                            disabled={isSubmit}
                            variant="contained"
                            color="primary"
                            className={classes.addDealerBtn}
                            type="submit"
                          >
                            ADD DEALER
                          </Button>
                        </Grid>
                      </form>
                    )}
                  </Mutation>
                )}
              </Mutation>
            );
          }}
        </Query>
      )}
    </>
  );
};

export default AddDealer;